import React from 'react';
import { cn } from '@/lib/utils';

interface IBlockCardProps {
	children?: any;
	title?: string;
	description?: string;
	className?: string;
	contentClassName?: string;
	highlight?: boolean;
}

export const BlockCard = ({ 
	children, 
	title, 
	description,
	className,
	contentClassName,
	highlight = false
}: IBlockCardProps) => {
	return (
		<div className={cn(
			"surface overflow-hidden transition-all duration-300",
	            "hover:-translate-y-[1px] hover:shadow-xl",
			highlight && "border-primary/40 bg-primary/5 ring-1 ring-primary/20",
			className
		)}>
			{(title || description) && (
				<div className="border-b border-border/60 bg-muted/30 px-5 py-4 backdrop-blur-sm sm:px-6">
					{title && (
						<h2 className="text-base font-semibold text-foreground/95">
							{title}
						</h2>
					)}
					{description && (
						<p className="text-sm text-muted-foreground/80 mt-1">
							{description}
						</p>
					)}
				</div>
			)}
			<div className={cn(
				"px-4 py-4 sm:px-6 sm:py-5",
				contentClassName
			)}>
				{children}
			</div>
		</div>
	);
};
